import CryptoJS from "crypto-js";

const keys = {
  defaultKey: "TfJwIrLsxM1R8*uiJdTd8ReT9sHn!V$a",
  requestDecryptKey: "FHHisyHATWRiV5osQRmarKNVSOeg3xM1",
  requestEncryptKey: "7el85O14pNOQ3HbqJ3JxJ10jR7BRcuD4",
  storageKey: "kfJwIrLsxM1R8*uiJdSr8ReT9sHn!Vzm",
  uploadKey: 'DH2SS%^&12vbDn6i8?sd5B2X3MLH_Ade'
}

const enType = {
  AES:'AES',
  DES: 'DES'
}

/**
 * 加密方法
 * @param data 待加密数据
 * @param enType 加密类型
 * @param key 加密的key
 */
export function encryptCX(data, enType = enType.AES, key = keys.defaultKey) {
  let encrypt = '';
  switch (enType) {
    case 'AES':
      encrypt = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
      break;
    case 'DES':
      encrypt = CryptoJS.DES.encrypt(data, key)
      break;
  }
  return encrypt.toString();
}

/**
 * 加密方法
 * @param data 待加密数据
 * @param enType 加密类型
 * @param key 加密的key
 */
export function decryptCX(data, enType = enType.AES, key = keys.defaultKey) {
  let encrypt = '';
  switch (enType) {
    case 'AES':
      var encryptedHexStr = CryptoJS.enc.Hex.parse(data);
      var decrypt = CryptoJS.AES.decrypt(CryptoJS.enc.Base64.stringify(encryptedHexStr), CryptoJS.enc.Utf8.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      encrypt = decrypt.toString(CryptoJS.enc.Utf8);
      break;
    case 'DES':
      var bytes = CryptoJS.DES.decrypt(data, key);
      encrypt = bytes.toString(CryptoJS.enc.Utf8);
      break;
  }
  return encrypt.toString();
}

export default {
  enType,
  keys,
  encryptCX,
  decryptCX
};
